import { AbstractControl, ValidationErrors } from '@angular/forms';

export function urlValidator(control: AbstractControl): ValidationErrors {
  if (control.value) {
    let url = control.value.trim();
    if (!validateUrl(url)) {
      return { invalidUrl: { value: url } };
    }
  }
  return null as any;
}

function validateUrl(url: string) {
  const urlRegex =
    /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
  return urlRegex.test(url);
}
